<div class="layout-content px-0 pb-0" [ngClass]="layoutMarginResponsive() && paddingTopResponsive()">
	<div *ngIf="iAmTechnician" [class]="onExtendedMobile() ? 'flex justify-content-center' : 'justify-content-start'">
		<p-tag value="{{('TECH_CODE' | translate) + ': ' + getTechnicianCode()}}" severity="info"
			styleClass="text-sm"></p-tag>
	</div>
	<div class="card" [class]="iAmTechnician ? 'mt-2' : 'mt-5'">
		<div class="flex flex-column justify-content-center align-items-center">
			<div class="grid col-12 p-0 px-2 mt-3 mb-5 lg:mb-3 sm:mt-0 md:p-1">
				<form (ngSubmit)="submit()" [formGroup]="userProfileForm" class="form-signin text-center mt-3">
					<div class="grid">
						<!-- ROW 1-->
						<div [ngClass]="col4Responsive()" class="pt-0 sm:pt-3">
							<div class="flex justify-content-between flex-wrap"
								[ngClass]="newShowErrors(this.f.firstName, 'borderRow')">
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.firstName, 'label')">{{ 'FIRST_NAME' | translate }}</div>
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.firstName, 'borderInput')">
									<input type="text" pInputText pAutoFocus [autofocus]="true"
										[ngClass]="dynamicInputTextWidth()" id="profile-input-firstName"
										formControlName="firstName" autocomplete="given-name"
										placeholder="{{ 'FIRST_NAME' | translate }}" maxlength="40" />
								</div>
							</div>
							<small *ngIf="showErrorRequiredMessage(this.f.firstName)"
								class="flex align-items-center text-50 pt-1" [ngClass]="justifyMessagesNewValidator()">{{
								'REQUIRED' | translate }}</small>
						</div>
						<div [ngClass]="col4Responsive()" class="pt-2 sm:pt-3">
							<div class="flex justify-content-between flex-wrap"
								[ngClass]="newShowErrors(this.f.lastName, 'borderRow')">
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.lastName, 'label')">{{ 'LAST_NAME' | translate }}</div>
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.lastName, 'borderInput')">
									<input type="text" pInputText [ngClass]="dynamicInputTextWidth()" id="profile-input-lastName"
										formControlName="lastName" autocomplete="family-name"
										placeholder="{{ 'LAST_NAME' | translate }}" maxlength="40" />
								</div>
							</div>
							<small *ngIf="showErrorRequiredMessage(this.f.lastName)"
								class="flex align-items-center text-50 pt-1" [ngClass]="justifyMessagesNewValidator()">{{
								'REQUIRED' | translate }}</small>
						</div>
						<div [ngClass]="col4Responsive()" class="pt-2 sm:pt-3">
							<div class="flex justify-content-between flex-wrap"
								[ngClass]="newShowErrors(this.f.birthDate, 'borderRow')">
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.birthDate, 'label')">{{ 'BIRTH_DATE' | translate }}</div>
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.birthDate, 'borderInput')">
									<p-calendar [showIcon]="true" inputId="icon" [ngClass]="dynamicInputTextWidth()"
										styleClass="{{ dynamicInputTextWidth() }}" inputStyleClass="pl-6 border-noround-right"
										id="profile-input-birthDate" formControlName="birthDate" autocomplete="bday"
										placeholder="dd/mm/yyyy" [minDate]="minDate" [maxDate]="maxDate" [defaultDate]="maxDate"
										dateFormat="dd/mm/yy" [panelStyleClass]="dynamicDatepicker()">
									</p-calendar>
								</div>
							</div>
							<!-- <small *ngIf="showErrorRequiredMessage(this.f.birthDate)" class="flex align-items-center text-50 pt-1" [ngClass]="justifyMessagesNewValidator()">{{ 'BIRTH_DATE_ERROR' | translate }}</small> -->
						</div>
						<!-- ROW 2-->
						<div [ngClass]="col4Responsive()" class="pt-2 sm:pt-3">
							<div class="flex justify-content-between flex-wrap"
								[ngClass]="newShowErrors(this.f.language, 'borderRow')">
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.language, 'label')">{{ 'LANGUAGE' | translate }}</div>
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.language, 'borderInput')">
									<p-dropdown [options]="languages" optionLabel="name" [ngClass]="dynamicInputTextWidth()"
										styleClass="{{ dynamicInputTextWidth() }} align-items-center pl-5"
										id="profile-input-language" formControlName="language"
										placeholder="{{ 'LANGUAGE' | translate }}" optionValue="code" dataKey="code">
									</p-dropdown>
								</div>
							</div>
							<small *ngIf="showErrorRequiredMessage(this.f.language)"
								class="flex align-items-center label-50 pt-1" [ngClass]="justifyMessagesNewValidator()">{{
								'REQUIRED' | translate }}</small>
						</div>
						<div [ngClass]="col4Responsive()" class="pt-2 sm:pt-3">
							<div class="flex justify-content-between flex-wrap"
								[ngClass]="newShowErrors(this.f.countryName, 'borderRow')">
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.countryName, 'label')">{{ 'COUNTRY' | translate }}</div>
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.countryName, 'borderInput')">
									<p-autoComplete formControlName="countryName" [suggestions]="filteredCountries"
										[ngClass]="dynamicInputTextWidth()" styleClass="{{ dynamicInputTextWidth() }}"
										inputStyleClass="pl-6 border-noround-right" id="profile-input-country"
										(completeMethod)="filterCountry($event)" field="name" [dropdown]="true"
										[virtualScroll]="true" [virtualScrollItemSize]="34"
										styleClass="p-autocomplete-panel-desktop" [forceSelection]="true">
									</p-autoComplete>
								</div>
							</div>
							<small *ngIf="showErrorRequiredMessage(this.f.countryName)"
								class="flex align-items-center text-50 pt-1" [ngClass]="justifyMessagesNewValidator()">{{
								'REQUIRED' | translate }}</small>
						</div>
						<div [ngClass]="col4Responsive()" class="pt-2 sm:pt-3">
							<div class="flex justify-content-between flex-wrap"
								[ngClass]="needsToBeDirty(this.f.phone, 'borderRow')">
								<div class="flex align-items-center justify-content-center"
									[ngClass]="needsToBeDirty(this.f.phone, 'label')">{{ 'PHONE_NUMBER' | translate }}</div>
								<div class="flex align-items-center justify-content-center"
									[ngClass]="needsToBeDirty(this.f.phone, 'borderInput')">
									<input type="text" pInputText [ngClass]="dynamicInputTextWidth()"
										id="registration-input-phoneNumber" formControlName="phone" autocomplete="tel"
										placeholder="(+39) 345 1234567" required maxlength="20" />
								</div>
							</div>
							<small *ngIf="showErrorInvalidMessage(this.f.phone)" class="flex align-items-center text-50 pt-1"
								[ngClass]="justifyMessagesNewValidator()">{{ 'PHONE_NUMBER_INVALID' | translate }}</small>
						</div>
						<!-- ROW 3 -->
						<div [ngClass]="col4Responsive()" class="pt-2 sm:pt-3">
							<div class="flex justify-content-between flex-wrap"
								[ngClass]="newShowErrors(this.f.email, 'borderRow')">
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.email, 'label')">{{ 'EMAIL' | translate }}</div>
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.email, 'borderInput')">
									<input type="text" pInputText [disabled]="true" [ngClass]="dynamicInputTextWidth()"
										[placeholder]="this.currentUser.Email" />
								</div>
							</div>
							<small *ngIf="showErrorRequiredMessage(this.f.email)" class="flex align-items-center text-50 pt-1"
								[ngClass]="justifyMessagesNewValidator()">{{ 'EMAIL_ADDRESS_INVALID' | translate }}</small>
						</div>
						<div [ngClass]="col4Responsive()" class="pt-2 sm:pt-3" *ngIf="iAmTechnician">
							<div class="flex justify-content-between flex-wrap"
								[ngClass]="newShowErrors(this.f.companyName, 'borderRow')">
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.companyName, 'label')">{{ 'COMPANY_NAME' | translate }}</div>
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.companyName, 'borderInput')">
									<input type="text" pInputText [ngClass]="dynamicInputTextWidth()"
										formControlName="companyName" id="registration-input-companyName"
										autocomplete="organization" placeholder="{{ 'COMPANY_NAME' | translate }}"
										maxlength="40" />
								</div>
							</div>
							<small *ngIf="showErrorRequiredMessage(this.f.companyName)"
								class="flex align-items-center text-50 pt-1" [ngClass]="justifyMessagesNewValidator()">{{
								'REQUIRED' | translate }}</small>
						</div>
						<div [ngClass]="col4Responsive()" class="pt-2 sm:pt-3" *ngIf="iAmTechnician">
							<div class="flex justify-content-between flex-wrap"
								[ngClass]="newShowErrors(this.f.headquarter, 'borderRow')">
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.headquarter, 'label')">{{ 'HEADQUARTER' | translate }}</div>
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.headquarter, 'borderInput')">
									<p-autoComplete formControlName="headquarter" [ngClass]="dynamicInputTextWidth()"
										styleClass="{{ dynamicInputTextWidth() }}"
										inputStyleClass="pl-6 sm:pl-5 border-noround-right" id="registration-input-headquarter"
										[suggestions]="filteredHeadquarters" (completeMethod)="filterHeadquarters($event)"
										field="Description" [dropdown]="true" [forceSelection]="true"
										[panelStyleClass]="dynamicAutocomplete()">
									</p-autoComplete>
								</div>
							</div>
							<small *ngIf="showErrorRequiredMessage(this.f.headquarter)"
								class="flex align-items-center text-50 pt-1" [ngClass]="justifyMessagesNewValidator()">{{
								'REQUIRED' | translate }}</small>
						</div>
						<div [ngClass]="col4Responsive()" class="pt-2 sm:pt-3">
							<div class="flex justify-content-between flex-wrap"
								[ngClass]="newShowErrors(this.f.password, 'borderRow')">
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.password, 'label')">{{ 'INSERT_NEW_PASSWORD' | translate }}
								</div>
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.password, 'borderInput')">
									<p-password formControlName="password" id="profile-input-password" maxLength="64"
										[toggleMask]="true" [feedback]="false" [ngClass]="dynamicInputTextWidth()"
										styleClass="{{ dynamicInputTextWidth() }}"
										inputStyleClass="{{ dynamicInputTextWidth() }} pl-2_5rem">
									</p-password>
								</div>
							</div>
							<small *ngIf="showErrorRequiredMessage(this.f.password)"
								class="flex align-items-center text-50 pt-1" [ngClass]="justifyMessagesNewValidator()">{{
								'PASSWORD_PATTERN_ERROR' | translate }}</small>
						</div>
						<div [ngClass]="col4Responsive()" class="pt-2 sm:pt-3">
							<div class="flex justify-content-between flex-wrap"
								[ngClass]="showErrorsConfirmFields(this.f.passwordConfirm, 'borderRow')">
								<div class="noSelectLabel-profile flex align-items-center justify-content-center"
									[ngClass]="showErrorsConfirmFields(this.f.passwordConfirm, 'label')">{{
									'CONFIRM_NEW_PASSWORD' | translate }}</div>
								<div class="flex align-items-center justify-content-center"
									[ngClass]="showErrorsConfirmFields(this.f.passwordConfirm, 'borderInput')">
									<p-password formControlName="passwordConfirm" id="profile-input-passwordConfirm"
										maxLength="64" [toggleMask]="true" [feedback]="false" [ngClass]="dynamicInputTextWidth()"
										styleClass="{{ dynamicInputTextWidth() }}"
										inputStyleClass="{{ dynamicInputTextWidth() }} pl-2_5rem">
									</p-password>
								</div>
							</div>
							<small *ngIf="showErrorConfirmInvalidMessage(this.f.passwordConfirm)"
								class="flex align-items-center text-50 pt-1" [ngClass]="justifyMessagesNewValidator()">{{
								'PASSWORDS_NOT_MATCH' | translate }}</small>
						</div>
					</div>
					<!-- ROW PRIVACY -->
					<div class="grid mt-6">
						<!-- NewsletterSubscription -->
						<div [class]="overTablet() ? 'col-3' : ''"></div>
						<div [class]="overTablet() ? 'col-6' : 'col-12'">
							<div class="flex justify-content-around flex-wrap">
								<div class="field-radiobutton">
									<p-radioButton value="true" formControlName="NewsletterSubscription" id="accept1"
										class="p-radiobutton-policy"></p-radioButton>
									<label for="accept1">{{ "ACCEPT" | translate }}</label>
								</div>
								<div class="field-radiobutton">
									<p-radioButton value="false" formControlName="NewsletterSubscription" id="refuse1"
										class="p-radiobutton-policy"></p-radioButton>
									<label for="refuse1">{{ "REFUSE" | translate }}</label>
								</div>
								<p innerHTML="{{ 'NewsletterSubscription' | translate }}"></p>
							</div>
						</div>
						<div [class]="overTablet() ? 'col-3' : ''"></div>
						<!-- TransferDataGroupCompanies -->
						<!-- <div class="col-12 md:col-6">
									<div class="flex justify-content-around flex-wrap">
										<div class="field-radiobutton">
											<p-radioButton value="true" formControlName="TransferDataGroupCompanies" id="accept2" class="p-radiobutton-policy"></p-radioButton>
											<label for="accept2">{{ "ACCEPT" | translate }}</label>
										</div>
										<div class="field-radiobutton">
											<p-radioButton value="false" formControlName="TransferDataGroupCompanies" id="refuse2" class="p-radiobutton-policy"></p-radioButton>
											<label for="refuse2">{{ "REFUSE" | translate }}</label>
										</div>
										<p innerHTML="{{ 'TransferDataGroupCompanies' | translate }}"></p>
									</div>
								</div> -->
					</div>

					<div class="grid mt-3">
						<div class="col-12" [class]="onExtendedMobile() ? '' : 'flex justify-content-center'">
							<button type="submit" pButton pRipple label="{{ 'CONFIRM' | translate }}"
								class="p-button-primary text-xl font-normal mb-2 mx-1" [ngClass]="dynamicButtonWidth()">
							</button>
							<button type="button" pButton pRipple (click)="backToHome()" label="{{ 'CANCEL' | translate }}"
								class="p-button-secondary text-xl font-normal mb-2 mx-1" [ngClass]="dynamicButtonWidth()">
							</button>
						</div>
					</div>

				</form>
			</div>

			<p-divider class="w-full"></p-divider>

			<div class="grid lg:px-5 flex justify-content-center text-center">
				<div class="col-12 flex justify-content-center text-center">
					<h3 class="page-title mb-0">{{ 'CLOSE_ACCOUNT_TITLE' | translate }}</h3>
				</div>
				<div class="col-12 flex justify-content-center text-center">
					<span class="paddedlr" [innerHTML]="'CLOSE_ACCOUNT_MESSAGE_SHORT' | translate"></span>
				</div>
				<div class="col-12 flex justify-content-center">
					<button type="button" pButton pRipple (click)="closeAccountPage()"
						label="{{ 'CLOSE_ACCOUNT_BUTTON' | translate }}" class="p-button-danger text-xl font-normal"
						[ngClass]="dynamicButtonWidth()">
					</button>
				</div>
			</div>
		</div>
	</div>
</div>